<template>
  <div>
    <el-table
      :data="tableData"
      size="mini"
      header-row-class-name="text-danger"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
    >
      <el-table-column
        label="Name"
        property="name"
      />
      <el-table-column
        label="Value"
        property="value"
      />
    </el-table>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'CourseCreationSummaryScreen',
  props: {
    courseSetupInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    userSetupInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      tableData: null,
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'text-align': 'center', 'overflow-wrap': 'break-word' }
    }
  },
  computed: {
    deliverStyleName: function () {
      if (this.courseSetupInfo.DeliveryStyle === '2') {
        return '2 Weekends'
      } else {
        return '1 Week'
      }
    },
    staffPositionName: function () {
      switch (this.userSetupInfo.StaffPositionId) {
        case '1':
          return 'Course Director'
        case '2':
          return 'ASM Programs'
        case '3':
          return 'ASM Logistics'
        case '4':
          return 'ASM Troop Guides'
        case '5':
          return 'Scribe'
        default:
          return ''
      }
    },
    startDate1Label: function () {
      if (this.courseSetupInfo.DeliveryStyle === '2') {
        return 'Weekend #1'
      } else {
        return 'Week Of'
      }
    },
    startDate1Value: function () {
      const sd = new Date(this.courseSetupInfo.Session1StartDate)
      const ed = new Date(this.courseSetupInfo.Session1StartDate)
      ed.setDate(sd.getDate() + 2)
      if (this.courseSetupInfo.DeliveryStyle === '1') {
        ed.setDate(sd.getDate() + 4)
      }

      return dayjs(sd).format('MMMM D') + ' to ' + dayjs(ed).format('MMMM D, YYYY')
    },
    startDate2Value: function () {
      if (this.courseSetupInfo.DeliveryStyle === '2') {
        const sd = new Date(this.courseSetupInfo.Session2StartDate)
        const ed = new Date(this.courseSetupInfo.Session2StartDate)
        ed.setDate(sd.getDate() + 1)

        return dayjs(sd).format('MMMM D') + ' to ' + dayjs(ed).format('MMMM D, YYYY')
      } else {
        return ''
      }
    },
    staffPriceName: function () {
      if (this.courseSetupInfo.ParticipantPrice) {
        let prefix = '$ '
        if (this.courseSetupInfo.StaffPrice.length === 2) {
          prefix = '$  '
        }
        return prefix + Number(this.courseSetupInfo.StaffPrice).toString() + '.00'
      } else {
        return '--'
      }
    },
    participantPriceName: function () {
      if (this.courseSetupInfo.ParticipantPrice) {
        let prefix = '$ '
        if (this.courseSetupInfo.ParticipantPrice.length === 2) {
          prefix = '$  '
        }
        return prefix + Number(this.courseSetupInfo.ParticipantPrice).toString() + '.00'
      } else {
        return '--'
      }
    }
  },
  methods: {
    refresh: function () {
      this.tableData = [{
        name: 'Course Name',
        value: this.courseSetupInfo.CourseName
      },
      {
        name: 'Host Council',
        value: this.courseSetupInfo.HostingCouncilName
      },
      {
        name: 'Curriculum Year',
        value: this.courseSetupInfo.CurriculumYear
      },
      {
        name: 'Delivery Style',
        value: this.deliverStyleName
      },
      {
        name: this.startDate1Label,
        value: this.startDate1Value
      },
      {
        name: 'Location',
        value: this.courseSetupInfo.Location1Name
      }]

      if (this.courseSetupInfo.DeliveryStyle === '2') {
        const wkend2 = [{
          name: 'Weekend #2',
          value: this.startDate2Value
        },
        {
          name: 'Location',
          value: this.courseSetupInfo.Location2Name
        }]
        this.tableData = this.tableData.concat(wkend2)
      }

      if (!this.$root.isLoggedIn) {
        const userInfo = [{
          name: 'Your Name',
          value: this.userSetupInfo.FirstName + ' ' + this.userSetupInfo.LastName
        },
        {
          name: 'Email Address',
          value: this.userSetupInfo.UserName
        },
        {
          name: 'Password',
          value: '**********'
        }]
        this.tableData = this.tableData.concat(userInfo)
      }

      const scouterInfo = [{
        name: 'Position on Course',
        value: this.staffPositionName
      },
      {
        name: 'Participant Price',
        value: this.participantPriceName
      },
      {
        name: 'Staff Price',
        value: this.staffPriceName
      }]
      this.tableData = this.tableData.concat(scouterInfo)
    },
    validate: function () {
      return true
    }
  }
}
</script>
